export default function parseDateToArgTime(date) {


    const parsedDate = new Date(date); 
    const parser = new Intl.DateTimeFormat('es-AR', {
        dateStyle: "short",
        timeStyle: "short"
    })
    return parser.format(parsedDate);
}